import i18n from "i18next";

import type { Key } from "api/services/treatment/schemas/Treatment";

export function translateTemplateKey(key: Key): string {
  const keyMap: Record<Key, string> = {
    achilles_tendinopathy: i18n.t("usercourse.templates.standardized.name.achilles_tendinopathy"),
    ankle_instability: i18n.t("usercourse.templates.standardized.name.ankle_instability"),
    fall_prevention: i18n.t("usercourse.templates.standardized.name.fall_prevention"),
    foot_oa_or_unspecified: i18n.t("usercourse.templates.standardized.name.foot_oa_or_unspecified"),
    general_elbow_pain: i18n.t("usercourse.templates.standardized.name.general_elbow_pain"),
    hallux_valgus: i18n.t("usercourse.templates.standardized.name.hallux_valgus"),
    hand_oa: i18n.t("usercourse.templates.standardized.name.hand_oa"),
    hip_oa: i18n.t("usercourse.templates.standardized.name.hip_oa"),
    hip_pain_unspecific: i18n.t("usercourse.templates.standardized.name.hip_pain_unspecific"),
    knee_instability: i18n.t("usercourse.templates.standardized.name.knee_instability"),
    knee_oa: i18n.t("usercourse.templates.standardized.name.knee_oa"),
    lateral_epicondylalgia: i18n.t("usercourse.templates.standardized.name.lateral_epicondylalgia"),
    low_back_pain: i18n.t("usercourse.templates.standardized.name.low_back_pain"),
    medial_epicondylalgia: i18n.t("usercourse.templates.standardized.name.medial_epicondylalgia"),
    neck: i18n.t("usercourse.templates.standardized.name.neck"),
    osteoporosis: i18n.t("usercourse.templates.standardized.name.osteoporosis"),
    patellofemoral_pain_syndrome: i18n.t("usercourse.templates.standardized.name.patellofemoral_pain_syndrome"),
    plantar_faschiit: i18n.t("usercourse.templates.standardized.name.plantar_faschiit"),
    post_op_hip: i18n.t("usercourse.templates.standardized.name.post_op_hip"),
    post_op_knee: i18n.t("usercourse.templates.standardized.name.post_op_knee"),
    pre_op_hip: i18n.t("usercourse.templates.standardized.name.pre_op_hip"),
    pre_op_knee: i18n.t("usercourse.templates.standardized.name.pre_op_knee"),
    shoulder_pain: i18n.t("usercourse.templates.standardized.name.shoulder_pain"),
    trochanterit: i18n.t("usercourse.templates.standardized.name.trochanterit"),
    wrist_pain: i18n.t("usercourse.templates.standardized.name.wrist_pain"),
  };

  return keyMap[key] || "";
}
